import { RichTextInput } from "@circle-react-uikit/RichTextInput";
import { QUICK_POST_V3_FOOTER_TOOLBAR_PORTAL_ID } from "@circle-react/components/QuickPostV3/constants";
import { useComposerSpace } from "@circle-react/components/QuickPostV3/hooks/useComposerSpace";
import { anchorClassNames } from "@circle-react/helpers/cssAnchorHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

export const Trix = () => {
  const { spaceId } = useComposerSpace();

  return (
    <RichTextInput
      id="post_body"
      name="body"
      is_private_space={false}
      space_id={spaceId}
      placeholder={t("quick_post_v2.body_placeholder")}
      tabIndex={0}
      toolbarPortalId={QUICK_POST_V3_FOOTER_TOOLBAR_PORTAL_ID}
      shouldRenderPopupsInBody
      toolbarWrapperClassName="[&_.toolbar]:flex [&_.toolbar]:items-center [&_.toolbar]:gap-1"
      className={classNames(
        anchorClassNames("trix-v2"),
        "[&_.trix-editor-textbox]:!border-none [&_.trix-editor-textbox]:!rounded-none [&_.trix-editor-textbox]:!px-0 [&_.trix-editor-textbox]:!py-2",
      )}
    />
  );
};
